export enum AuthState {
	Initial = 0, // nothing currently known
	Anonymous = 1, // msal says not logged on 
	Authenticated = 2, // msal says logged on 
	Acknowledged = 3 // api service returned with user info
}
